// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { xLoadingOverlayHandlerType } from "@steiner/App/Handlers/XNG/LoadingOverlay";
import { Draft } from "immer";

export type xLoadingOverlayStateType = Readonly<{
    loadingOverlay?: string[];
}>;

export const initialLoadingOverlay: xLoadingOverlayStateType = {
    loadingOverlay: [],
};

const reducer = {
    "xCommon/loadingOverlay": (
        draft: Draft<xLoadingOverlayStateType>,
        action: { data: xLoadingOverlayHandlerType },
    ) => {
        const { key, id } = action.data;
        const { loadingOverlay } = draft;

        switch (key) {
            case "add":
                if (!loadingOverlay?.includes(id)) {
                    draft.loadingOverlay = loadingOverlay ? [...loadingOverlay, id] : [id];
                }
                break;
            case "remove":
                draft.loadingOverlay = loadingOverlay?.filter((item: string) => id.indexOf(item) === -1);
                break;
            case "clear":
                if (id) {
                    draft.loadingOverlay = loadingOverlay?.filter((item: string) => id.indexOf(item) === -1);
                } else {
                    draft.loadingOverlay = [];
                }
                break;
            default:
                break;
        }
    },
};

const xLoadingOverlay = createTypedReducerWithImmer(initialLoadingOverlay, reducer);

(reducers as any).xLoadingOverlay = xLoadingOverlay;

export type xLoadingOverlayState = {
    xLoadingOverlay: xLoadingOverlayStateType;
} & ApplicationState;

type xLoadingOverlayReducers = {
    [key: string]: typeof xLoadingOverlay;
};

export type xLoadingOverlayActions = Parameters<xLoadingOverlayReducers[keyof xLoadingOverlayReducers]>[1] | AnyAction;
